export default {
    namespaced:  true,
    state: {
        isMainSidebarOpen: false
    },
    getters: {
        isMainSidebarOpen: state => {
            return state.isMainSidebarOpen;
        }
    },
    actions: {
        openMainSidebar(context) {
            if(context.rootGetters.isMobile && context.rootState.isTasksSidebarOpen)
                context.state.isTasksSidebarOpen = false;

            context.state.isMainSidebarOpen = true;
        },
        closeMainSidebar(context) {
            context.state.isMainSidebarOpen = false;
        }
    }
}